import { render, staticRenderFns } from "./CheckoutPlansTable.vue?vue&type=template&id=2bfc6398"
import script from "./CheckoutPlansTable.vue?vue&type=script&lang=js"
export * from "./CheckoutPlansTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports